export default {
  name: 'Name',
  edit: {
    form: 'name-input',
    label: 'Edit Name',
    handler: value => value,
  },
};
